import {
  SAVE_SCORE_REPORT_DETAILS,
  POST_TEST_SCORE_TO_SERVER,
  GET_SCORE_FEEDBACK,
} from "./types";

// Save Score Report
export const saveReportScoreDetails = (data) => (dispatch) => {
  dispatch({
    type: SAVE_SCORE_REPORT_DETAILS,
    payload: data,
  });
};

// Post test score to server
const postScoreEndpoint = "rest_post_score.php";
export const postTestScore = (payload) => (dispatch, getState, Api) => {
  // FLAG-GETURL
  return Api.post(postScoreEndpoint, payload).then((response) => {
    dispatch({
      type: POST_TEST_SCORE_TO_SERVER,
    });
    return response;
  });
};

// Get score feedback
const getScoreFeedbackEndpoint = "rest_get_feedback.php";
export const getScoreFeedback = (params) => (dispatch, getState, Api) => {
  // FLAG-GETURL
  return Api.get(getScoreFeedbackEndpoint + params).then((response) => {
    dispatch({
      type: GET_SCORE_FEEDBACK,
    });
    return response;
  });
};
